<template>
  <div
    id="avatar"
    v-tooltip="{
      content: calculatedText,
      trigger: 'click, hover',
      offset: '5px'
    }"
    ref="avatar"
    @click.stop
  >
    <div class="avatar-inner" ref="avatar-inner">
      <div class="avatar-text" ref="avatar-text">
        <span
          class="char"
          :style="`font-size: ${fontSize}`"
          v-for="(item, index) in generatedCharacters.slice(0, 3)"
          :key="index"
        >
          {{ item.substring(0, 1) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    size: {
      type: String,
      required: false,
      default: "50px"
    },
    fontSize: {
      type: String,
      required: false,
      default: "15px"
    },
    color: {
      type: String,
      required: false
      // default: "linear-gradient( 90deg, #DA1B5A, #ff5b91)"
    },
    borderColor: {
      type: String,
      required: false
      // default: "#DA1B5A"
    },
    fontColor: {
      type: String,
      required: false,
      default: "white"
    },
    text: {
      type: String,
      required: false,
      default: ""
    }
  },
  mounted() {
    if (this.borderColor) {
      this.$refs.avatar.style["border"] = "1px solid" + this.borderColor;
    }
    if (this.color) {
      this.$refs["avatar-inner"].style["background"] = this.color;
    }
    this.$refs.avatar.style.width = this.size;
    this.$refs.avatar.style.height = this.size;
    this.$refs["avatar-text"].style.color = this.fontColor;
  },
  computed: {
    calculatedText() {
      return `<span style="font-size: 12px">${this.text}</span>`;
    },
    generatedCharacters() {
      const arr = this.text.trim().split(" ");
      let newArr = [];
      for (const item in arr) {
        if (arr[item] !== "") {
          newArr.push(arr[item]);
        }
      }
      return newArr;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#avatar {
  border-radius: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $color-primary;
  .avatar-inner {
    // height: 95%;
    // width: 95%;
    height: calc(100% - 2px);
    width: calc(100% - 2px);
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(90deg, $color-primary, $color-light-primary);
    .avatar-text {
      display: flex;
      flex-direction: row;
      .char {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
    }
  }
}
</style>
